// Manufacturing Skills organized by subcategories
export const MANUFACTURING_SKILLS_CATEGORIES = [
  {
    name: 'Production Management',
    skills: [
      'Production Planning', 'Process Control', 'Production Scheduling',
      'Capacity Planning', 'Resource Allocation', 'Workflow Optimization',
      'Production Efficiency', 'Output Management', 'Line Balancing',
      'Production Coordination', 'Batch Processing', 'Production Monitoring',
      'Process Flow', 'Production Strategy', 'Operations Management'
    ]
  },
  {
    name: 'Quality Control',
    skills: [
      'Quality Assurance', 'Quality Standards', 'Inspection Methods',
      'Quality Testing', 'Defect Analysis', 'Quality Metrics',
      'Statistical Control', 'Quality Systems', 'Compliance Testing',
      'Quality Documentation', 'Process Validation', 'Quality Improvement',
      'Quality Auditing', 'Quality Planning', 'Performance Standards'
    ]
  },
  {
    name: 'Process Improvement',
    skills: [
      'Lean Manufacturing', 'Six Sigma', 'Continuous Improvement',
      'Process Optimization', 'Efficiency Analysis', 'Waste Reduction',
      'Value Stream Mapping', 'Kaizen', '5S Methodology',
      'Process Analysis', 'Performance Metrics', 'Standard Work',
      'Root Cause Analysis', 'Process Innovation', 'Best Practices'
    ]
  },
  {
    name: 'Equipment and Maintenance',
    skills: [
      'Preventive Maintenance', 'Equipment Operation', 'Troubleshooting',
      'Machine Setup', 'Equipment Calibration', 'Maintenance Planning',
      'Tool Management', 'Equipment Safety', 'Repair Procedures',
      'Technical Documentation', 'Maintenance Scheduling', 'Equipment Testing',
      'Performance Monitoring', 'Reliability Engineering', 'Asset Management'
    ]
  },
  {
    name: 'Safety and Compliance',
    skills: [
      'Safety Protocols', 'OSHA Compliance', 'Risk Assessment',
      'Safety Training', 'Emergency Procedures', 'Environmental Compliance',
      'Hazard Control', 'Safety Documentation', 'Regulatory Compliance',
      'Safety Auditing', 'Incident Investigation', 'Safety Management',
      'PPE Management', 'Safety Standards', 'Workplace Safety'
    ]
  },
  {
    name: 'Inventory and Materials',
    skills: [
      'Inventory Management', 'Material Planning', 'Stock Control',
      'Supply Chain', 'Material Handling', 'Warehouse Management',
      'Inventory Control', 'Material Flow', 'Storage Systems',
      'Inventory Tracking', 'Material Requirements', 'Cost Management',
      'Supplier Relations', 'Inventory Analysis', 'Resource Planning'
    ]
  },
  {
    name: 'Manufacturing Technology',
    skills: [
      'CNC Operation', 'Automation Systems', 'PLC Programming',
      'Robotics', 'CAD/CAM Systems', 'Manufacturing Software',
      'Process Control Systems', 'Equipment Programming', 'Digital Manufacturing',
      'Smart Manufacturing', 'IoT Integration', 'System Integration',
      'Technology Implementation', 'Machine Learning', 'Data Analytics'
    ]
  },
  {
    name: 'Project Management',
    skills: [
      'Project Planning', 'Resource Management', 'Timeline Management',
      'Cost Control', 'Team Coordination', 'Risk Management',
      'Project Documentation', 'Stakeholder Management', 'Change Management',
      'Performance Tracking', 'Quality Control', 'Process Implementation',
      'Project Strategy', 'Results Delivery', 'Success Metrics'
    ]
  },
  {
    name: 'Team Leadership',
    skills: [
      'Team Management', 'Performance Management', 'Training Development',
      'Staff Coordination', 'Team Building', 'Communication Skills',
      'Leadership Skills', 'Conflict Resolution', 'Employee Development',
      'Motivation Skills', 'Team Planning', 'Performance Evaluation',
      'Team Coordination', 'Staff Training', 'Workforce Management'
    ]
  },
  {
    name: 'Cost Management',
    skills: [
      'Cost Analysis', 'Budget Management', 'Cost Reduction',
      'Financial Planning', 'Resource Allocation', 'Cost Control',
      'Expense Management', 'ROI Analysis', 'Cost Optimization',
      'Financial Reporting', 'Cost Tracking', 'Budget Planning',
      'Resource Planning', 'Cost Efficiency', 'Financial Strategy'
    ]
  },
  {
    name: 'Environmental Management',
    skills: [
      'Environmental Compliance', 'Waste Management', 'Sustainability',
      'Energy Efficiency', 'Environmental Standards', 'Green Manufacturing',
      'Resource Conservation', 'Environmental Impact', 'Recycling Programs',
      'Environmental Monitoring', 'Pollution Control', 'Environmental Policy',
      'Sustainable Practices', 'Environmental Planning', 'Carbon Footprint'
    ]
  },
  {
    name: 'Documentation and Reporting',
    skills: [
      'Technical Documentation', 'Process Documentation', 'Report Generation',
      'Data Analysis', 'Performance Reporting', 'Quality Records',
      'Compliance Documentation', 'Standard Operating Procedures', 'Work Instructions',
      'Document Control', 'Record Keeping', 'Documentation Systems',
      'Report Analysis', 'Data Management', 'Information Systems'
    ]
  }
];

// Export flattened list for backward compatibility
export const MANUFACTURING_SKILLS = MANUFACTURING_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
